module.exports = __webpack_public_path__ + "img/cp-mp-r4-1.77e55b92.jpg";